import { ToggleMenuContext } from '@/context';
import { useContext } from 'react';

export const useToggleMenu = () => {
  const context = useContext(ToggleMenuContext);
  return context;
};
